import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

export default class PrivacyTOSLinks extends React.Component {
    static propTypes = {
      siteName: PropTypes.string.isRequired,
      tosUrl: PropTypes.string.isRequired,
      privacyPolicyUrl: PropTypes.string.isRequired,
    };

    render() {
      const a1 = (...chunks) => (<a href={this.props.tosUrl} target="_blank" rel="noopener noreferrer">{chunks}</a>);
      const a2 = (...chunks) => (<a href={this.props.privacyPolicyUrl} target="_blank" rel="noopener noreferrer">{chunks}</a>);

      return (
        <FormattedMessage
          id=''
          defaultMessage='By signing up or creating an account, you agree to the {domain} <a1>Terms</a1> & <a2>Privacy Policy</a2>.'
          description='Disclaimer text on signup and login page. `domain` is "HelloSign" or "HelloFax"'
          values={{ domain: this.props.siteName, a1, a2 }} />
      );
    }
}
